import { useState, useRef, useEffect } from 'react';
import * as Yup from 'yup';
import { useSelector } from 'react-redux';
import { createUserPaymentMethod } from '@/services/userPaymentMethodsService';

export const usePaymentData = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const languageData = useSelector((state) => state.lenguage?.lang);

  const [selectedCard, setSelectedCard] = useState({
    type: 'visa',
    icon: 'https://upload.wikimedia.org/wikipedia/commons/5/5e/Visa_Inc._logo.svg',
    name: 'Visa',
  });

  const [showDropdown, setShowDropdown] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowDropdown(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleSubmit = async (paymentData) => {
    setLoading(true);
    setError(null);

    try {
      console.log('Datos tokenizados recibidos en el hook tarjeta:', paymentData);

      const payload = {
        user_id: paymentData.user_id,
        payment_method_id: paymentData.payment_method_id || 1,
        details: paymentData.details,
        token: paymentData.token,
        cardNumber: paymentData.cardNumber,
        customerId: paymentData.customerId,
        customerEmail: paymentData.email,
        isDefault: paymentData.isDefault ? 1 : 0,
        id_state: 1,
      };

      console.log('ver el payload: ', payload);

      const response = await createUserPaymentMethod(payload);

      console.log('Respuesta API createUserPaymentMethod:', response);

      return response;
    } catch (err) {
      console.error(err);
      setError(
        languageData === 'EN'
          ? 'Payment processing failed. Please try again.'
          : 'Error al procesar el pago. Inténtalo nuevamente.',
      );
      throw err;
    } finally {
      setLoading(false);
    }
  };

  const validationSchema = Yup.object().shape({
    cardHolder: Yup.string()
      .min(2, languageData === 'EN' ? 'Minimum 2 characters' : 'Mínimo 2 caracteres')
      .required(languageData === 'EN' ? 'Required' : 'Requerido'),

    email: Yup.string()
      .email(languageData === 'EN' ? 'Invalid email' : 'Email inválido')
      .required(languageData === 'EN' ? 'Required' : 'Requerido'),
  });

  /*
  const handleSubmit = async (values, onPaymentProcess) => {
    setLoading(true);
    setError(null);
    try {
      await onPaymentProcess(values);
    } catch (err) {
      setError('Payment processing failed. Please try again.');
    } finally {
      setLoading(false);
    }
  };
  */

  const handleCardSelect = (card) => {
    setSelectedCard(card);
    setShowDropdown(false);
  };

  const toggleDropdown = () => {
    setShowDropdown((prev) => !prev);
  };

  return {
    loading,
    error,
    handleSubmit,
    selectedCard,
    showDropdown,
    dropdownRef,
    handleCardSelect,
    toggleDropdown,
    validationSchema,
  };
};
